/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  ARIA_LABEL_selectLabel: 'ARIA_LABEL_selectLabel',
  groupRequestModuleLabel: 'groupRequestModuleLabel',
  mainLabel: 'mainLabel',
  travelDetailsInfo: 'travelDetailsInfo',
  freeTextInfo: 'freeTextInfo',
  adult: 'adult',
  child: 'child',
  ageOfChildLabel: 'ageOfChildLabel',
  ageOfChildInfo: 'ageOfChildInfo',
  adultAgeRange: 'adultAgeRange',
  childAgeRange: 'childAgeRange',
  year: 'year',
  year_plural: 'year_plural',
  age: 'age',
  button: {
    close: 'button.close',
    send: 'button.send',
    bookHere: 'button.bookHere',
    clickHere: 'button.clickHere',
    set: 'button.set'
  },
  field: {
    selectTravelDates: 'field.selectTravelDates',
    travelers: 'field.travelers'
  },
  messages: {
    error: 'messages.error',
    userNotLoggedInError: 'messages.userNotLoggedInError',
    success: 'messages.success',
    notEnoughParticipants: 'messages.notEnoughParticipants'
  }
}; export default Keys;